import React from "react"

class AlertDanger extends React.Component {
  render() {
    return (
      <div className="bg-red-100 text-red-700 text-semibold px-4 py-2 my-2 border-l-4 border-red-700 rounded">
        {this.props.children}
      </div>
    )
  }
}

export default AlertDanger
